/**
 * Utility function to store the viewport's width and
 * other responsive information into the global store.
 */

export const setupViewportInfo = (GlobalStore, STORE_ACTIONS, BREAKPOINTS, UTILITIES) => {
	const fontSize = parseInt(
		getComputedStyle(document.documentElement).getPropertyValue('font-size')
	);
	let width = window.innerWidth;

	// Convert EM breakpoints to PX according to font-size
	const PX_BREAKPOINTS = {
		XS: Math.floor(BREAKPOINTS.XS * fontSize),
		SM: Math.floor(BREAKPOINTS.SM * fontSize),
		MD: Math.floor(BREAKPOINTS.MD * fontSize),
		LG: Math.floor(BREAKPOINTS.LG * fontSize),
	};

	const viewportInfo = {
		// Breakpoints converted to PX
		XS: PX_BREAKPOINTS.XS,
		SM: PX_BREAKPOINTS.SM,
		MD: PX_BREAKPOINTS.MD,
		LG: PX_BREAKPOINTS.LG,
		// Shortcuts
		isXS: width <= PX_BREAKPOINTS.XS,
		isSM: width > PX_BREAKPOINTS.XS && width <= PX_BREAKPOINTS.SM,
		isMD: width > PX_BREAKPOINTS.SM && width <= PX_BREAKPOINTS.MD,
		isLG: width > PX_BREAKPOINTS.MD && width <= PX_BREAKPOINTS.LG,
		isXL: width > PX_BREAKPOINTS.LG,
		// Viewport width in PX
		width,
	};

	GlobalStore.dispatch(STORE_ACTIONS.setViewportInfo(viewportInfo));

	// Update store's viewport data on window redize
	window.addEventListener(
		'resize',
		UTILITIES.general.debounce(function () {
			width = window.innerWidth;
			viewportInfo.isXS = width <= PX_BREAKPOINTS.XS;
			viewportInfo.isSM = width > PX_BREAKPOINTS.XS && width <= PX_BREAKPOINTS.SM;
			viewportInfo.isMD = width > PX_BREAKPOINTS.SM && width <= PX_BREAKPOINTS.MD;
			viewportInfo.isLG = width > PX_BREAKPOINTS.MD && width <= PX_BREAKPOINTS.LG;
			viewportInfo.isXL = width > PX_BREAKPOINTS.LG;
			viewportInfo.width = width;
			GlobalStore.dispatch(STORE_ACTIONS.setViewportInfo(viewportInfo));
		}, 500)
	);
};
